import { collection, findSelector, resource } from "data/helpers/apiv3";
import { Milestone } from "data/records";

const [api, actions] = resource(Milestone, [["list", collection.get("", ["goalId", "privacyCode"])]]);

const selectors = {
  ...findSelector(Milestone),
  byGoalId: (state, goalId) => state.apiv3.milestone.id.filter((m) => m.goalId === goalId),
};

const reducers = {};

const initialState = {};

export {
  api as milestoneApi,
  actions as milestoneActions,
  selectors as milestoneSelectors,
  reducers as milestoneReducers,
  initialState as milestoneInitialState,
};
